class CardImages extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const sectionId = this.dataset.sectionId;
    const enableSlider = this.dataset.enableSlider === 'true';

    if (enableSlider) {
      this.initSlider();
    }
    
    // Hacer las tarjetas completamente clickables
    this.makeCardsClickable();
  }

  makeCardsClickable() {
    const cards = this.querySelectorAll('.card-media');
    
    cards.forEach(card => {
      const link = card.querySelector('.card-media--link');
      
      if (link) {
        card.style.cursor = 'pointer';
        
        card.addEventListener('click', function(e) {
          // No redirigir si se hace clic en un botón
          if (!e.target.closest('.btn') && !e.target.closest('a')) {
            window.location.href = link.href;
          }
        });
      }
    });
  }

  initSlider() {
    const items = parseInt(this.dataset.items) || 2;
    const tabletItems = parseInt(this.dataset.tabletItems) || 2;

    const swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: tabletItems,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: items,
          spaceBetween: 20,
        },
      },
    });
  }
}

customElements.define('card-images', CardImages);
